import { SHOW_NOTIFICATION } from '../types';

export default (message, severity) => ({
  type: SHOW_NOTIFICATION,
  message,
  severity,
});
